module.exports = __webpack_public_path__ + "img/sx_code.7ffcbfa6.png";